'use strict';
/**
 * Squiz Animations library
 * @type {Object}
 */
var sqAnimations = {};
